import React, { useCallback } from 'react';
import { Checkbox, CheckboxProps } from '@el8/vital';
import { useFormikContext } from 'formik';
import { MergeWithPriority } from 'types';

type Props = MergeWithPriority<
  {
    name: string;
  },
  CheckboxProps
>;

/**
 * A Formik-integrated version of Checkbox. `onChange` and `checked` are automatically
 * wired up based on the `name` prop passed in.
 */
const CheckboxFormik: React.FC<Props> = ({ name, ...props }) => {
  const { isSubmitting, setFieldValue, values } = useFormikContext<{ [field: string]: boolean }>();

  const handleChange = useCallback(
    (event: React.FormEvent): void => {
      setFieldValue(name, (event.target as HTMLInputElement).checked);
    },
    [name, setFieldValue],
  );

  return (
    <Checkbox checked={values[name]} disabled={isSubmitting} onChange={handleChange} {...props} />
  );
};

export default CheckboxFormik;
